
const Shadow = props => {
	if (!props.data) return null
	return <div className="skin-shadow"></div>
};

export default Shadow
